/* global Blockly */
import React from 'react';
import MobiControlCore from './MobiControlCore';

function defineBlock(context) {
    let prop = {...context};
    prop.blockText = "get device enrolled state";
    prop.tooltipText = "Get value if device is enrolled with MobiControl or not.";
    prop.responseText = "is enrolled";
    prop.responseBlockType = "boolean_response";
    let blockInstance = MobiControlCore(prop);
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            return `Snap.mcDeviceDetails.isEnrolled(${coreResponseCode});\n`;
        }
    }
}

const MobiControlGetIsEnrolled = function (props) {
    const name = 'snap_mobicontrol_getisenrolled';
    MobiControlGetIsEnrolled.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

export default MobiControlGetIsEnrolled;